import type { ReactNode } from 'react'

export type BadgeTone = 'success' | 'warning' | 'danger' | 'info' | 'gray' | 'primary' | 'accent' | 'violet'

export interface BadgeProps {
  tone?: BadgeTone
  children: ReactNode
  className?: string
  title?: string
}

export function Badge({ tone = 'gray', children, className = '', title }: BadgeProps) {
  return (
    <span className={`badge badge-${tone} ${className}`} title={title}>
      {children}
    </span>
  )
}

/** One place for the colours of every status word in the kit. */
export function statusTone(status: string): BadgeTone {
  switch (status) {
    case 'live':
    case 'succeeded':
    case 'verified':
    case 'sent':
    case 'ok':
    case 'pass':
    case 'match':
    case 'stored':
    case 'offer':
    case 'approved':
    case 'built':
      return 'success'
    case 'tested':
    case 'preview':
    case 'waiting':
    case 'queued':
    case 'pending':
    case 'warning':
      return 'warning'
    case 'failed':
    case 'error':
    case 'timed_out':
    case 'rejected':
    case 'mismatch':
    case 'wrong':
    case 'fail':
    case 'suspended':
      return 'danger'
    case 'running':
    case 'info':
    case 'received':
      return 'info'
    case 'draft':
      return 'primary'
    case 'retired':
    case 'cancelled':
    case 'skipped':
      return 'gray'
    case 'production':
      return 'accent'
    case 'uat':
      return 'violet'
    default:
      return 'gray'
  }
}

export function StatusBadge({ status, className }: { status: string; className?: string }) {
  return (
    <Badge tone={statusTone(status)} className={className}>
      {status.replace(/_/g, ' ')}
    </Badge>
  )
}
